import { render, staticRenderFns } from "./ChildAct.vue?vue&type=template&id=0489df8f&scoped=true"
import script from "./ChildAct.vue?vue&type=script&lang=js"
export * from "./ChildAct.vue?vue&type=script&lang=js"
import style0 from "./ChildAct.vue?vue&type=style&index=0&id=0489df8f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489df8f",
  null
  
)

export default component.exports